import {IErrorEvent} from '../../../api/network';
import {api} from '../../../api/proto';
import i18n from '../../../i18n';

export default function getCreateWorkspaceTagError(error?: IErrorEvent | null, res?: api.IWorkspaceCreateTagResponse | null): string | null {
  if (error) {
    return error.message || 'Unknown error';
  }

  switch (res?.status) {
    case api.WorkspaceCreateTagResponse.Status.WCT_INTERNAL_ERROR:
      return i18n.t('tags_create_workspace_tag_internal_error');
    case api.WorkspaceCreateTagResponse.Status.WCT_ALREADY_ADDED:
      return i18n.t('tags_create_workspace_tag_already_added');
  }

  return null;
}
